import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { stepperIncrease } from 'actions/view'
import { receiveTemplate, selectEmailCard, set } from 'actions/template'
import { template as templateObj } from 'components/routes'
import List from 'components/ListView/List'
import { withRouter } from 'react-router-dom'
import { reduce } from 'lodash'

const styles = theme => ({
  list: {
    [theme.breakpoints.down('sm')]: {
      padding: '10px 12px 0',
    },
  },
})

export default withRouter(
  connect(
    state => ({
      templatesById: state.email.templatesById,
      sectionsLength: Boolean(state.email.sections.length),
      smsTemplatesById: Object.values(
        state.data?.['sms/template'] || {},
      )?.reduce?.((acc, el) => {
        acc[el.id] = { ...el, type: 'sms' }
        return acc
      }, {}),
    }),
    dispatch => {
      return bindActionCreators(
        {
          stepperIncrease,
          selectEmailCard,
          receiveTemplate,
          set,
        },
        dispatch,
      )
    },
  )(
    withStyles(styles)(
      ({
        templatesById,
        classes,
        cols,
        taskForm,
        stepperIncrease,
        selectEmailCard,
        receiveTemplate,
        sectionsLength,
        set,
        modal,
        smsTemplates,
        smsTemplatesById,
        history,
      }) => {
        const onClick = template => {
          if (smsTemplates) {
            Promise.resolve(receiveTemplate(template)).then(() => {
              selectEmailCard('sms')
              stepperIncrease('task')
            })
          } else {
            if (sectionsLength) {
              if (
                window.confirm(
                  'This will replace all content currently in your editor. Are you sure?',
                )
              ) {
                Promise.resolve(receiveTemplate(template)).then(() => {
                  selectEmailCard('blank')
                  stepperIncrease('task')
                })
              }
            } else {
              Promise.resolve(receiveTemplate(template)).then(() => {
                selectEmailCard('blank')
                stepperIncrease('task')
              })
            }
          }
        }

        const templateProp = smsTemplates
          ? {
              ...templateObj,
              onClick,
              listState: state =>
                reduce(
                  state.data?.['sms/template'] || {},
                  (result, value, key) => {
                    result[key] = { ...value, type: 'sms' }
                    return result
                  },
                  {},
                ),
            }
          : {
              ...templateObj,
              onClick,
              listState: state => state.email.templatesById,
            }

        return (
          <div className={classes.list}>
            <List history={history} {...templateProp} />
          </div>
        )
      },
    ),
  ),
)

// new onClick
//         onClick={() => {
//           if (smsTemplates) {
//             selectEmailCard('sms')
//             stepperIncrease('task')
//             receiveTemplate('new')
//           } else {
//             if (sectionsLength) {
//               if (
//                 window.confirm(
//                   'This will replace all content currently in your editor. Are you sure?',
//                 )
//               ) {
//                 stepperIncrease('task')
//                 selectEmailCard('blank')
//                 receiveTemplate('new')
//               }
//             } else {
//               stepperIncrease('task')
//               selectEmailCard('blank')
//               receiveTemplate('new')
//             }
//           }
//         }}
